class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (event) => {
      const removeCouponButton = event.target.closest('.remove-discount-code');
      if (!removeCouponButton || removeCouponButton.disabled) return;
      event.preventDefault();
      this.removeCouponCode(removeCouponButton);
    });
  }

  removeCouponCode(button) {
    if (button) {
      button.disabled = true;
    }
    setPendingDiscount('');

    return fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
    })
      .catch((error) => {
        console.warn("Discount-update response could not be read, refreshing cart anyway:", error.message);
      })
      .then(() => fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`))
      .then((response) => response.json())
      .then((response) => {
        this.renderContents({ sections: response });
      })
      .catch((error) => {
        console.error("Error refreshing cart after removing discount:", error.message);
        if (button) {
          button.disabled = false;
        }
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // Refresh cart sections to catch changes made at checkout (discounts removed, etc)
    const wasPromoOpen = document.querySelector('.promo-code-wrap.open') !== null;
    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((response) => {
        // Update sections directly without calling renderContents() which would call open() again
        const sections = [
          { id: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'cart-icon-bubble' }
        ];
        sections.forEach((section) => {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (sectionElement && response.sections[section.id]) {
            sectionElement.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
          }
        });
        // Restore promo open state if it was open before refresh
        if (wasPromoOpen) {
          const promoWrap = document.querySelector('.promo-code-wrap');
          if (promoWrap) promoWrap.classList.add('open');
        }
      })
      .catch((error) => {
        console.warn("Could not refresh cart drawer:", error.message);
      });

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    // The menu drawer and the header search are not rendered on every header layout,
    // so both are optional here.
    const menuDrawer = document.querySelector("#Details-menu-drawer-container");
    if(menuDrawer && menuDrawer.hasAttribute("open")){
      menuDrawer.removeAttribute("open");
      menuDrawer.classList.remove("menu-opening");
      const menuIcon = document.querySelector(".header__icon--menu");
      if(menuIcon) menuIcon.setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet");
      const sectionHeader = document.querySelector(".section-header");
      if(sectionHeader) sectionHeader.classList.remove("menu-open");
    }
    const searchDetails = document.querySelector(".header__search details");
    if(searchDetails && searchDetails.hasAttribute("open")){
      searchDetails.removeAttribute("open");
      const sectionHeader = document.querySelector(".section-header");
      if(sectionHeader) sectionHeader.classList.remove("menu-open");
    }
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState,discount,discountcode) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
    });
  }
}

customElements.define('promo-code-wrap', PromoCodeSection);

// A free shipping code is only calculated on the checkout page, so it never shows
// up in the cart totals. We keep it here and push it through /discount on checkout.
const PENDING_DISCOUNT_KEY = 'matat_pending_discount_code';

function setPendingDiscount(code) {
  try {
    if (code) {
      sessionStorage.setItem(PENDING_DISCOUNT_KEY, code);
    } else {
      sessionStorage.removeItem(PENDING_DISCOUNT_KEY);
    }
  } catch (error) {
    // sessionStorage is unavailable (private browsing) - the code stays on the cart anyway
  }
}

function getPendingDiscount() {
  try {
    return sessionStorage.getItem(PENDING_DISCOUNT_KEY) || '';
  } catch (error) {
    return '';
  }
}

class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }

  applyCouponCode(discountCode) {
    return fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountCode }),
    }).catch((error) => {
      console.warn("Discount-update response could not be read, refreshing cart anyway:", error.message);
    });
  }

  // The rendered cart sections only tell us whether money came off the cart, so we
  // read the cart JSON as well to know what kind of code was entered.
  getCartState() {
    return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .catch((error) => {
        console.warn("Cart JSON could not be read:", error.message);
        return null;
      });
  }

  // Returns 'applied' | 'shipping' | 'invalid' | 'unknown'
  classifyCouponCode(cart, code) {
    if (!cart) return 'unknown';

    const wanted = code.trim().toLowerCase();
    const matches = (value) => String(value || '').trim().toLowerCase() === wanted;

    // Order level discount - shows in the cart totals
    const cartLevel = (cart.cart_level_discount_applications || []).find(
      (application) => matches(application.title) || matches(application.key) || matches(application.code)
    );
    if (cartLevel) {
      return cartLevel.target_type === 'shipping_line' ? 'shipping' : 'applied';
    }

    // Product level discount - shows on the line items
    const lineLevel = (cart.items || []).some((item) =>
      (item.discounts || []).some((discount) => matches(discount.title)) ||
      (item.line_level_discount_allocations || []).some(
        (allocation) => matches(allocation.discount_application && allocation.discount_application.title)
      )
    );
    if (lineLevel) return 'applied';

    // Nothing came off the cart. Either the code is a shipping discount that Shopify
    // stores on the cart and only calculates at checkout, or it is simply not valid.
    const storedCodes = cart.discount_codes || [];
    const stored = storedCodes.find((discount) => matches(discount.code));

    // Shopify only keeps a code on the cart when it accepted it, so a stored code that
    // took nothing off the cart is a shipping discount.
    if (!stored || stored.applicable === false) return 'invalid';
    return 'shipping';
  }

  submitForm(discountCode){
    const code = (discountCode || '').trim();
    if (!code) return;
    const submitButton = this.querySelector('.btn-promo');
    if (submitButton) {
      submitButton.disabled = true;
    }
    this.applyCouponCode(code)
      .then(() => Promise.all([
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`).then((response) => response.json()),
        this.getCartState(),
      ]))
      .then(([sections, cart]) => {
        const discountsHTML = sections['cart-drawer'];
        const promoWasOpen = document.querySelector('.promo-code-wrap.open') !== null;

        // Update sections directly (don't use renderContents to avoid double-refresh)
        const drawer = document.querySelector('cart-drawer');
        const drawerInner = drawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
        document.querySelector('#CartDrawer').innerHTML = drawer.getSectionInnerHTML(discountsHTML, '#CartDrawer');
        const iconBubble = document.querySelector('cart-icon-bubble') || document.getElementById('cart-icon-bubble');
        if (iconBubble) {
          iconBubble.innerHTML = drawer.getSectionInnerHTML(sections['cart-icon-bubble']);
        }

        // A shipping code leaves no cart discount, so the panel would collapse and hide the message
        const promoWrap = document.querySelector('.promo-code-wrap');
        if (promoWrap && promoWasOpen) promoWrap.classList.add('open');

        let state = this.classifyCouponCode(cart, code);
        if (state === 'unknown') {
          state = discountsHTML && discountsHTML.includes('discount-code-chip') ? 'applied' : 'invalid';
        }

        // The section was re-rendered, so these are fresh elements
        const errorMsg = document.querySelector('cart-coupon-form .error');
        const input = document.querySelector('cart-coupon-form input[type="text"]');
        const newSubmitButton = document.querySelector('cart-coupon-form .btn-promo');

        if (state === 'applied') {
          // Code applied - hide error, clear input
          setPendingDiscount('');
          if (errorMsg) {
            errorMsg.classList.add('d-none');
            errorMsg.classList.remove('error--notice');
          }
          if (input) input.value = '';
        } else if (state === 'shipping') {
          // Free shipping discount - only calculated at checkout, so keep it for the
          // checkout redirect and tell the customer where it will show up
          setPendingDiscount(code);
          if (errorMsg) {
            errorMsg.textContent = errorMsg.dataset.errorShipping || 'ההטבה תתעדכן בעמוד התשלום';
            errorMsg.classList.add('error--notice');
            errorMsg.classList.remove('d-none');
          }
          if (input) input.value = '';
        } else {
          // Code didn't apply - show invalid message, keep code in field
          setPendingDiscount('');
          if (errorMsg) {
            errorMsg.textContent = errorMsg.dataset.errorInvalid || 'קוד קופון לא חוקי.';
            errorMsg.classList.remove('error--notice');
            errorMsg.classList.remove('d-none');
          }
          if (input) input.value = code;
        }

        if (newSubmitButton) {
          newSubmitButton.disabled = false;
        }
      })
      .catch(error => {
        console.error("Error applying discount:", error.message);
        const currentButton = document.querySelector('cart-coupon-form .btn-promo') || submitButton;
        if (currentButton) {
          currentButton.disabled = false;
        }
      });
  }
}

customElements.define('cart-coupon-form', CartCouponCodeButton);

document.addEventListener('click', function (event) {
  const checkoutBtn = event.target.closest('#CartDrawer-Checkout');
  if (!checkoutBtn) return;
  const pendingCode = getPendingDiscount();
  if (!pendingCode) return;
  event.preventDefault();
  const noteEl = document.querySelector('#CartDrawer-Note');
  const note = noteEl ? noteEl.value : '';
  const discountCheckoutUrl = "https://" + window.location.host + "/discount/" + encodeURIComponent(pendingCode) + "?redirect=/checkout";
  const goToCheckout = function () {
    window.location.href = discountCheckoutUrl;
  };
  if (note !== '') {
    fetch(`${routes.cart_url}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).then(goToCheckout).catch(goToCheckout);
  } else {
    goToCheckout();
  }
});




